import { render } from "./GeneratedInvoice.vue?vue&type=template&id=565b8008&ts=true"
import script from "./GeneratedInvoice.vue?vue&type=script&lang=ts"
export * from "./GeneratedInvoice.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__